import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';
import { InductionConfigDetail } from 'src/app/models/inductionconfigdetail.model';
import { Job, PickupJob, UnallocateJob } from 'src/app/models/job.model';
import { Site } from 'src/app/models/site.model';
import { User } from 'src/app/models/user.model';
import { VisitReason } from 'src/app/models/visitreason.model';
import { AuthService } from 'src/app/services/auth/auth.service';
import { JobService } from 'src/app/services/job/job.service';
import { SiteService } from 'src/app/services/site/site.service';
import { LocalizationService } from '../internationalization/localization.service';
import { ReferenceService } from 'src/app/services/reference/reference.service';
import { FormService } from 'src/app/services/form/form.service';
import { InductionConfig } from 'src/app/models/inductionconfig.model';
import { AllocatedJobVisitReason } from '@app/models/allocatedjobvisitreason.model';
import { environment } from '@env/environment';
import { ComplianceCheckAnswerModel } from '@app/models/inductionqna.model';
import { CompanyType, JobType } from '@app/shared/enums';

@Component({
    selector: 'app-reason-for-visit',
    templateUrl: './reason-for-visit.component.html',
    styleUrls: ['./reason-for-visit.component.scss'],
    standalone: false
})
export class ReasonForVisitComponent implements OnInit {
  @Input() inductionConfigDetail : any = '';
  jobsAllocated : Job[] = [];
  jobsParentUser : Job[] = [];
  currentUser : User | undefined;
  selectedSite : Site | undefined;
  reasonForVisitConfig : InductionConfigDetail | undefined;
  reasonsForVisit : VisitReason[] = [];
  inductionConfig: InductionConfig | undefined;
  pickupJob : PickupJob | undefined;
  language : string = environment.defaultLang.toLowerCase();
  complianceCheckAnswer: ComplianceCheckAnswerModel | undefined;
  
  constructor(private _localizationService : LocalizationService,
              private _authService : AuthService,
              private _jobService : JobService,
              private _siteService : SiteService,
              private _referenceService : ReferenceService,
              private _formService : FormService,
              private _router : Router) { }

  ngOnInit(): void {
    this._authService.getUser().then(user => {
      if (user){
        this.currentUser = user;
        if (this.inductionConfigDetail){
          this.reasonForVisitConfig = this.inductionConfigDetail;
        }
        this.loadComplianceCheck();
      }
    });

    this._localizationService.get().then((l) => {
      if(l){
        this.language = l.toLowerCase();
      }
    });
    
  }

  loadComplianceCheck() {
    this._formService.getInductionConfig().then(
      inductionConfigResult => {
        if (inductionConfigResult) {
          this.inductionConfig = inductionConfigResult;
          const complianceCheckQnAs = inductionConfigResult.inductionConfigDetails.filter(i => i.type.toLowerCase() == "compliancecheck");
    
          if (complianceCheckQnAs && complianceCheckQnAs.length > 0) {
            if (complianceCheckQnAs[0]?.answer) {
              this.complianceCheckAnswer = JSON.parse(complianceCheckQnAs[0]?.answer) as ComplianceCheckAnswerModel;
            }
          }
          this.getSiteData();
        }
        else {
          this._router.navigate(['signin']);
        }
      },
      error => {
        alert("Failed to get induction info.");
        this._siteService.removeSignedInSite();
        this._router.navigate(['signin']);
      });
    
  }
  
  getVisitReasons(){
    if (this.inductionConfig?.visitorId) { 
        this._referenceService.getVisitReasons(this.inductionConfig.visitorId, true).subscribe({
          next: (visitReason) => {
            if (visitReason){
              this.reasonsForVisit = visitReason;
              this.reasonsForVisit.forEach(rs => {
                rs.displayDescription = rs.translations!
                  .find(s => s.languageCode.toLowerCase() == this.language)?.description ?? rs.description;
              })
              if (this.reasonForVisitConfig && this.reasonForVisitConfig.answer?.length > 0) {
                let visitReasonsArray = this.reasonForVisitConfig.answer.split(',');          
                visitReasonsArray.forEach(vra => {
                  let reason = this.reasonsForVisit.find(x => x.displayDescription == vra);
                  if (reason) reason.selected = true;
                });
              }
            } else console.log("getVisitReasons : No visit reasons retrieved"); 
          },
          error: (error) => {
            if (error.error && error.error.errorCode) {
              alert(this._localizationService.translate(error.error.errorCode));
            }
            else {
              alert(this._localizationService.translate("reasonforvisit_error_get_visitreason"));
            }
          }
        });
    }
  }

  private getSiteData() {
    this._siteService.getSignedInSite().then(site => {
      if (site) {
        this.selectedSite = site;
        if (this.inductionConfig?.visitorId) { 
          this.getVisitReasons();
        }else{
          this.getUserJobs();
        }
      } else {
        this._router.navigate(['signin']);
      }
     },
      error => {
        alert("Failed to get site info.");
        this._router.navigate(['signin']);
     });
  }

  private getUserJobs(): void {
    let newVisitReason: boolean = false;
    if (this.currentUser){
      if (!this.reasonForVisitConfig || this.reasonForVisitConfig.answer == undefined || this.reasonForVisitConfig.answer == ""){
        newVisitReason = true;
      }
      if (this.selectedSite) {
        this._jobService.getJobsByCompanyRefNumber(this.selectedSite.id).subscribe({
            next: jobs => {
              if (jobs){
                let filteredJobsByComplianceCompany : Job[] = [];
                if (this.complianceCheckAnswer && this.complianceCheckAnswer?.companyId) {
                  var selectedCompany = this.currentUser?.companies.find(c => c.id == this.complianceCheckAnswer?.companyId);
                   if (selectedCompany?.companyType.toUpperCase() == CompanyType.SUBCON) {
                    filteredJobsByComplianceCompany = jobs.filter(job => job.allocatedReferenceId == selectedCompany?.referenceNumber);
                  }
                  else {
                    filteredJobsByComplianceCompany = jobs.filter(job => job.companyReferenceNumber == selectedCompany?.referenceNumber);
                  }
                } else {
                  filteredJobsByComplianceCompany = jobs;
                }

                filteredJobsByComplianceCompany.forEach(job => {
                    if (job.allocatedUserEmail){
                      if (newVisitReason) {
                        this.onJobCheck(true, job);
                      }
                      this.jobsAllocated.push(job);
                    }
                    else {
                      var adminJob =  this.currentUser?.companies.find(c => c.referenceNumber == job.companyReferenceNumber && 
                                                                            c.companyType.toUpperCase() == CompanyType.SELF);
                      if (adminJob){
                        if (newVisitReason) {
                          this.onJobCheck(true, job);
                        }
                        this.jobsAllocated.push(job);
                      }
                      else{
                        this.jobsParentUser.push(job);
                      }
                    }
                })
                this.checkSelectedJob();
             } 
            },
            error: e => {
              if (e.error && e.error.errorCode) {
                alert(this._localizationService.translate(e.error.errorCode));
              }
              else {
                alert(this._localizationService.translate("reasonforvisit_error_get_job"));
              }
            }
        })    
      }
    }  
  }

  public enableUnallocated(job: Job): boolean {
      return this.currentUser?.companies?.find(x => x.referenceNumber == job.companyReferenceNumber)?.companyType.toUpperCase() == CompanyType.PARENT ? true : false;
  }

  pickupJobOnClick(selectedJob : Job){
    if (this.currentUser){
      let company = this.currentUser.companies.find(c => c.referenceNumber == selectedJob.companyReferenceNumber);
      if (company){
        this.pickupJob = {
          jobId : selectedJob.referenceNumber,
          resourceId : selectedJob.companyReferenceNumber,
          subContractorEmail : this.currentUser.emailAddress,
          companyName : company.name,
          technicianName : this.currentUser.firstName + ' ' + this.currentUser.lastName,
          mobileNumber : this.currentUser.mobileNumber,
          jobType : selectedJob.jobType
        }

        this._jobService.pickupJob(this.pickupJob).subscribe(
          {
            next : result => {
              if(result){    
                this.jobsAllocated.push(selectedJob);
                this.onJobCheck(true, selectedJob);
                this.jobsParentUser = this.jobsParentUser.filter(j => j !== selectedJob);
              }
            },
            error : error =>{
              if (error.error && error.error.errorCode) {
                alert(this._localizationService.translate(error.error.errorCode));
              }
              else {
                alert(this._localizationService.translate("reasonforvisit_pickup_job_save_error"));
              }
            }
          }
        )
      }
    }
   
  }

  checkSelectedJob(){
    if (this.reasonForVisitConfig){
      if (this.reasonForVisitConfig.answer != undefined && this.reasonForVisitConfig.answer != ""){
        let jobSelected: boolean = false;
        let configAnswer = this.reasonForVisitConfig.answer.toLowerCase();
        this.jobsAllocated.forEach(job => {
          if (configAnswer.indexOf(job.referenceNumber) > -1){
             job.reasonForVisitCheck = true;
             jobSelected = true;
          }
        });
        if (!jobSelected) {
          this.reasonForVisitConfig.answer = "";
          this.jobsAllocated.forEach(job => {
             this.onJobCheck(true, job);
          });
        }
      }
    }
  }

  onJobCheck(checked: boolean, job: Job) {
    if (this.reasonForVisitConfig) {
      if (checked) {
        const newVisitReason: AllocatedJobVisitReason = {
          jobNumber: job.referenceNumber,
          jobType: job.jobType,
          calloutReferenceNumber: job.calloutReferenceNumber,
          status: job.jobStatusName,
          version: job.version,
          isUnallocated: false
        };
        if (this.reasonForVisitConfig.answer != undefined && this.reasonForVisitConfig.answer != "") {
          let existingVisitReasons: AllocatedJobVisitReason[] = JSON.parse(this.reasonForVisitConfig.answer);
          existingVisitReasons.push(newVisitReason);
          this.reasonForVisitConfig.answer = JSON.stringify(existingVisitReasons);
        }
        else {
          this.reasonForVisitConfig.answer = JSON.stringify([newVisitReason]);
        }
        job.reasonForVisitCheck = true;
        this._siteService.addVisitReason(job);
      }
      else {
        if (this.reasonForVisitConfig.answer != undefined && this.reasonForVisitConfig.answer != "") {
          this._siteService.removeVisitReason(job);
          const existingVisitReasons: AllocatedJobVisitReason[] = JSON.parse(this.reasonForVisitConfig.answer);
          const updatedReasons = existingVisitReasons.filter(reason => reason.jobNumber !== job.referenceNumber);

          this.reasonForVisitConfig.answer = updatedReasons.length > 0 ? JSON.stringify(updatedReasons) : "";
        }
      }
    }
  }

  onReasonForVisitSelect(vr : VisitReason){
    if (this.reasonForVisitConfig && this.reasonsForVisit) {
      vr.selected = !vr.selected;
      this.reasonForVisitConfig.answer = this.reasonsForVisit
        .filter(x => x.selected).map(f => {return f.displayDescription}).join(",");

      var addReasons = this.reasonsForVisit.filter(x => x.selected);  

      this._siteService.removeAllVisitReasons();  
      addReasons.forEach(e => {
         this._siteService.addVisitorTypeReason(e, this.inductionConfig?.visitorId);
      });    
    }
  }

  isReactiveJob(job : Job){
    return (job.jobType == JobType.REACTIVE_JOB) ? true : false;
  }

  isPPMJob(job : Job){
     return (job.jobType == JobType.PPM_JOB) ? true : false;
  }

   unallocateJobOnClick(selectedJob : Job){
    if (confirm(this._localizationService.translate("reasonforvisit_unallocate_job_confirm"))) {

        var unallocatedJob : UnallocateJob = {
          jobId : selectedJob.referenceNumber,
          resourceId : selectedJob.companyReferenceNumber,
          calloutReferenceNumber : selectedJob.calloutReferenceNumber,
          jobType : selectedJob.jobType
        }

        this._jobService.unallocateJob(unallocatedJob).subscribe(
          {
            next : result => {
              if(result){    
                this.jobsParentUser.push(selectedJob);
                this.onJobCheck(false, selectedJob);
                this.jobsAllocated = this.jobsAllocated.filter(j => j !== selectedJob);
              }
            },
            error : error =>{
              if (error.error && error.error.errorCode) {
                alert(this._localizationService.translate(error.error.errorCode));
              }
              else {
                alert(this._localizationService.translate("reasonforvisit_unallocate_job_save_error"));
              }
            }
          }
        )
    }
  }
}